var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop_index"
  }, [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.bannerItem.mediaCode,
      "width": "1400",
      "height": "120"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "hq-shop-header"
  }, [_c('div', {
    staticClass: "w1200 bc bd"
  }, [_c('ul', {
    staticClass: "hq-shop-nav"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "all-goods pr",
    on: {
      "mouseenter": function($event) {
        _vm.goodsCateShow()
      },
      "mouseleave": function($event) {
        _vm.goodsCateHidden()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/shop_goods_list'
      }
    }
  }, [_vm._v("全部商品"), _c('i', {
    staticClass: "dp-ico-a-1"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "categorys-dropdown none"
  }, _vm._l((_vm.catList), function(carBo, index) {
    return (index < 6) ? _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/shop_goods_list',
          query: {
            catCode: _vm.catBo.catCode,
            shopCode: _vm.shopCode
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.catBo.catNameCn))])], 1) : _vm._e()
  }))], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-dp-selector mt20"
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('dl', [_c('dt', [_vm._v("已选条件：")]), _vm._v(" "), _c('dd', {
    attrs: {
      "id": "choosedCond"
    }
  }, _vm._l((_vm.choosedCondItem), function(condItem, index) {
    return _c('span', {
      staticClass: "checked-item",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "condType": condItem.condType
      }
    }, [_vm._v(_vm._s(condItem.condName)), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.removeCondition(index)
        }
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('dl', [_c('dt', [_vm._v("价格：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', 'intervalAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '0,10000')
      }
    }
  }, [_vm._v("1万以下")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '10000,20000')
      }
    }
  }, [_vm._v("1-2万")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '20000,30000')
      }
    }
  }, [_vm._v("2-3万")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '30000,50000')
      }
    }
  }, [_vm._v("3-5万")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '50000,100000')
      }
    }
  }, [_vm._v("5-10万")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '100000,200000')
      }
    }
  }, [_vm._v("10-20万")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '200000,500000')
      }
    }
  }, [_vm._v("20-50万")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '500000,1000000')
      }
    }
  }, [_vm._v("50-100万")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '1000000')
      }
    }
  }, [_vm._v("100万以上")])])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("分类：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'cat', 'categoryAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _vm._l((_vm.shopCatList), function(shopCat) {
    return _c('a', {
      on: {
        "click": function($event) {
          _vm.chooseCondition($event, 'cat', 'shopCat.catCode')
        }
      }
    }, [_vm._v(_vm._s(shopCat.catNameCn))])
  })], 2)]), _vm._v(" "), _c('dl', {
    staticClass: "b-n"
  }, [_c('dt', [_vm._v("发布时间：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'timeAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneDay')
      }
    }
  }, [_vm._v("一天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'twoDay')
      }
    }
  }, [_vm._v("两天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneWeek')
      }
    }
  }, [_vm._v("一周内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneMonth')
      }
    }
  }, [_vm._v("一月内")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "shop-tabbox-1 shop-jp-tj"
  }, [_c('div', {
    staticClass: "hd hd-2"
  }, [_c('div', {
    staticClass: "pro-tool-2 fr"
  }, [_c('ul', [_c('li', {
    class: {
      "hover": _vm.sortCondition === "defaultSort"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('defaultSort')
      }
    }
  }, [_vm._v("默认")]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "saleAmount"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('saleAmount')
      }
    }
  }, [_vm._v("销量"), _c('i', {
    class: {
      "up": _vm.sortSaleAmount == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "publishTime"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('publishTime')
      }
    }
  }, [_vm._v("发布时间"), _c('i', {
    class: {
      "up": _vm.sortPublishTime == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "price"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('price')
      }
    }
  }, [_vm._v("价格"), _c('i', {
    class: {
      "up": _vm.sortPrice == "asc"
    }
  })])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('ul', _vm._l((_vm.shopGoodsItems), function(good) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(good.goodsCode)
        }
      }
    }, [_c('p', {
      staticClass: "pic tc"
    }, [_c('a', [_c('img', {
      attrs: {
        "src": good.imgMiddle,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', [_vm._v(_vm._s(good.goodsName))])]), _vm._v(" "), _c('p', {
      staticClass: "other"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v("¥" + _vm._s(good.unitPrice))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "dp-pages tc"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.prePage()
      }
    }
  }, [_vm._v(" < ")]), _vm._v(" "), _vm._l((_vm.pageList), function(page) {
    return _c('a', {
      class: {
        "current_page": _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          _vm.queryByPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_vm._v(" > ")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "hover"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticClass: "hover"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("全部商品")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/footer-ad-1.png"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32512b52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/shop/shop_goods_list.vue
// module id = WYj9
// module chunks = 1